import type { ReactNode } from 'react';

export function StatusBadge({ tone = 'neutral', children }: { tone?: 'neutral' | 'success' | 'warning' | 'danger'; children: ReactNode }) {
  return <span className={`status-badge status-badge--${tone}`}>{children}</span>;
}

export function PageSkeleton() {
  return <div className="page-skeleton" aria-label="正在加载"><span /><span /><span /></div>;
}
